import styled from "styled-components"

const Tiles = ({children, ...props}) => {
	return (
		<TilesWrapper {...props}>
			{children}
		</TilesWrapper>
	)
}

const Tile = ({children, ...props}) => {
	return <TileWrapper {...props}>{children}</TileWrapper>
}

export {
	Tiles,
	Tile
}

const TilesWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4.44rem;
    max-width: 1160px;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
        gap: 2.22rem;
    }
`

const TileWrapper = styled.div`
    display: flex;
    flex-direction: column;

    img {
        width: 100%;
        height: auto;
        object-fit: cover;
        margin-bottom: 1rem;
    }
`
